// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Header from "./components/Header";
import AgeGate from "./components/AgeGate";
import Footer from "./components/Footer";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import DMCA from "./components/DMCA";
import Statement2257 from "./components/2257";
import "./App.css";

function App() {
  return (
    <div className="App">
      <AgeGate>
        <Router>
          <Header />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/dmca" element={<DMCA />} />
            <Route path="/2257" element={<Statement2257 />} />
          </Routes>
          <Footer />
        </Router>
      </AgeGate>
    </div>
  );
}

export default App;
